import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-data-form',
  templateUrl: './data-form.component.html',
  styleUrls: ['./data-form.component.css'],
})
export class DataFormComponent implements OnInit, OnDestroy {
  @Input() data: any[];
  @Input() sent: boolean;
  @Output() changed = new EventEmitter<FormArray>();

  _sent: boolean;
  form: FormGroup;
  private onDestroy = new Subject<void>();

  constructor(private formBuilder: FormBuilder) {}

  get dataFA(): FormArray {
    return this.form.controls._data as FormArray;
  }

  ngOnDestroy(): void {
    this.onDestroy.next();
    this.onDestroy.complete();
  }

  ngOnInit() {
    this.form = this.formBuilder.group({
      _data: this.formBuilder.array([]),
    });

    if (this.data && Array.isArray(this.data)) {
      for (let i = 0, len = this.data.length; i < len; i++) {
        const d = this.data[i];
        this.addData(this.initData(d));
      }
    }

    this.onChanged();

    this.form.controls._data.valueChanges
      .pipe(takeUntil(this.onDestroy))
      .subscribe(() => this.onChanged());
  }

  onAddData(): void {
    this.addData(this.initData());
  }

  onChanged(): void {
    this.changed.emit(this.form.controls._data as FormArray);
  }

  onRemoveData(i: number): void {
    const dataFA = this.form.controls._data as FormArray;
    dataFA.removeAt(i);
  }

  private addData(dataCtrl: FormGroup): void {
    this.dataFA.push(dataCtrl);
  }

  private initData(data: any = {}): FormGroup {
    const fg = this.formBuilder.group({
      name: ['', Validators.required],
      value: [''],
      // options: this.formBuilder.group({
      //   onPDF: [!this.save],
      // }),
    });

    fg.patchValue(data, { emitEvent: false, onlySelf: true });
    return fg;
  }
}
